/*
 | ==============================================================================
 | Memberhub answers 403 with data.reason = 'email_unverified' when a route needs
 | a verified email (verify.activated middleware, CLUB-899). checkResponse()
 | rejects with { code, data: <response body> }, so the reason sits at
 | error.data.data.reason. A 403 without it (policy / API-token denial) is a real
 | error and must not be treated as "verify your email".
 | ==============================================================================
 */
export const EMAIL_UNVERIFIED_REASON = 'email_unverified'

export function isEmailVerificationRequired (error) {
  return parseInt(error?.code) === 403 && error?.data?.data?.reason === EMAIL_UNVERIFIED_REASON
}
